export const MEMBER_ALREADY_MOUNTED_GUIDES = [
  'member.overview',
  'member.incoming-invites',
  'member.profile',
  'member.settings',
] as const

export const MEMBER_TAB_SCREEN_GUIDES: Record<string, string> = {
  'for-you': 'member.todos',
  todos: 'member.todos',
  board: 'member.board',
  controls: 'member.controls',
  calendar: 'member.calendar',
  chat: 'member.chat',
  meetings: 'member.meetings',
  class: 'member.class',
}

export const MEMBER_AI_MODE_GUIDES: Record<string, string> = {
  CREATE: 'member.ai.create',
  EXECUTE: 'member.ai.execute',
  PULSE: 'member.ai.pulse',
  HISTORY: 'member.ai.history',
  MAGIC: 'member.ai.create',
}

export const MEMBER_NEXUS_PANEL_GUIDES: Record<string, string> = {
  CHAT: 'member.chat',
  CALENDAR: 'member.calendar',
  MEETINGS: 'member.meetings',
  HUDDLE: 'member.meetings',
}

export const memberScreenGuideId = (
  activeTab: string | null | undefined,
  aiMode?: string | null,
  nexusPanel?: string | null,
): string | undefined => {
  if (!activeTab) return undefined
  const tab = activeTab.toLowerCase()

  if (tab === 'for-you' || tab === 'todos') {
    return MEMBER_TAB_SCREEN_GUIDES['for-you']
  }

  if (tab === 'board') {
    return MEMBER_TAB_SCREEN_GUIDES.board
  }

  if (tab === 'controls') {
    return MEMBER_TAB_SCREEN_GUIDES.controls
  }

  if (tab === 'nexus') {
    const panelKey = (nexusPanel ?? 'CHAT').toUpperCase()
    return MEMBER_NEXUS_PANEL_GUIDES[panelKey] ?? MEMBER_TAB_SCREEN_GUIDES.chat
  }

  if (tab === 'ai') {
    const modeKey = (aiMode ?? 'CREATE').toUpperCase()
    return MEMBER_AI_MODE_GUIDES[modeKey] ?? MEMBER_AI_MODE_GUIDES.CREATE
  }

  if (tab === 'calendar') {
    if (nexusPanel && MEMBER_NEXUS_PANEL_GUIDES[nexusPanel.toUpperCase()]) {
      return MEMBER_NEXUS_PANEL_GUIDES[nexusPanel.toUpperCase()]
    }
    return MEMBER_TAB_SCREEN_GUIDES.calendar
  }

  if (tab === 'chat') {
    if (nexusPanel && MEMBER_NEXUS_PANEL_GUIDES[nexusPanel.toUpperCase()]) {
      return MEMBER_NEXUS_PANEL_GUIDES[nexusPanel.toUpperCase()]
    }
    return MEMBER_TAB_SCREEN_GUIDES.chat
  }

  if (tab === 'meetings') {
    return MEMBER_TAB_SCREEN_GUIDES.meetings
  }

  if (tab === 'class') {
    return MEMBER_TAB_SCREEN_GUIDES.class
  }

  return undefined
}
